export const FRANCHISE_BILLING_STATUS = {
  paid: { label: '납부 완료', className: 'bg-green-100 text-green-800' },
  pending: { label: '납부 대기', className: 'bg-yellow-100 text-yellow-800' },
  overdue: { label: '연체', className: 'bg-red-100 text-red-800' },
  waived: { label: '면제', className: 'bg-gray-100 text-gray-700' }
};

export function formatBillingDate(dateString) {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('ko-KR');
}

export function formatBillingCurrency(amount) {
  return `₩${Number(amount || 0).toLocaleString()}`;
}

export function getBillingStatusMeta(status) {
  return FRANCHISE_BILLING_STATUS[status] || FRANCHISE_BILLING_STATUS.pending;
}
